<template>
  <div>
    <v-container v-if="okContainer()">
      <v-navigation-drawer
        v-model="toggle"
        absolute
        right
        light
        temporary
        width="300px"
        @transitionend="toggleAlertBarDrawer"
      >
        <v-list-item>
          <v-list-item-avatar class="avatar">
            <v-icon>mdi-bell</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ translatedText('alerts') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <Transaction
          v-if="session.loggedIn"
          :menu="menu()"
          :session="session"
          :environment="environment"
          :generalExApplicationEx="generalExApplicationEx"
          :applicationName="applicationName"
          :method="'get'"
          :customLanguage="customLanguage"
          :custom="{
            hideHeader: true,
            small: true,
            hideWait: true,
            hideEmbed: true,
            queryMode: interactive ? 'INTERACTIVE' : 'BACKGROUND'
          }"
          ref="transactionRef"
          @after-bring-data="afterBringData"
          @after-parse-query-api="parseQueryApi"
        />
      </v-navigation-drawer>
    </v-container>
  </div>
</template>

<script>
import Transaction from "./../transaction/Transaction";
export default {
  name: "AlertBarFrame",
  props: [
    "alertBarDrawer",
    "session",
    "environment",
    "applicationName",
    "generalExApplicationEx",
    "customLanguage",
  ],
  data() {
    return {
      toggle: false,
      loading: false,
      transactionEx: null,
      transactionLoaded: false,
      queryData: null,
      queryCount: null,
      queryLoaded: false,
      alertsTimeout: null,
      interactive: false,
    };
  },
  components: {
    Transaction,
  },
  methods: {
    toggleAlertBarDrawer() {
      this.toggle = !this.toggle;
      if (this.toggle) {
        this.loadAlerts();
      } else {
        this.closeAlerts();
      }
    },

    menu() {
      return {
        transactionName: this.getAlertsData(this.generalExApplicationEx)
          .transactionName,
        selected: true,
      };
    },

    loadAlerts() {
      this.interactive = true;
      this.$refs.transactionRef.callTransaction(this.menu(), null);
    },

    closeAlerts() {
      if (this.interactive && this.queryData && this.queryData.length > 0) {
        const action = this.transactionEx.actions.find(
          (action) => action.type == "bulkContent"
        );
        if (action) {
          this.$refs.transactionRef.callAction({
            action,
            inputData: this.queryData
          });
        }
      }
      this.interactive = false;
      this.$refs.transactionRef.exitTransaction();
    },

    afterBringData(args) {
      this.transactionEx = args.transactionEx;
      this.transactionLoaded = args.transactionLoaded;
    },

    parseQueryApi(args) {
      this.queryData = args.queryData;
      this.queryCount = args.queryCount;
      this.queryLoaded = args.queryLoaded;
      if (!this.interactive) {
        this.$emit("update-alerts", { count: this.queryCount });
      }
    },

    queryAlertsBackground() {
      if (this.alertsIntervalEnabled(this.generalExApplicationEx)) {
        if (!this.transactionLoaded) {
          this.$refs.transactionRef.bringData({
            transactionName: this.getAlertsData(this.generalExApplicationEx)
              .transactionName,
          });
        }
      }
    },

    parseAlertsTimeout() {
      if (this.alertsTimeout) {
        clearTimeout(this.alertsTimeout);
      }
      this.alertsTimeout = setTimeout(() => {
        if (this.alertsIntervalEnabled(this.generalExApplicationEx)) {
          this.queryAlertsBackground();
        }
        this.parseAlertsTimeout();
      }, 5000);
    },

    loadAlertsBackground() {
      this.parseAlertsTimeout();
    },

    okContainer() {
      return this.session?.loggedIn;
    }
  },
};
</script>

<style>
</style>